<div class="np-form-control dx-fieldset">
  <dx-validation-group id="MAIN">
    <div *ngIf="productTranslation != null" class="dx-field">
      <div class="dx-field-label"></div>
      <div class="dx-field-value d-flex flex-row">
        <div class="flex-fill align-self-center">
          <img class="flag" src="images/flags/de.gif"/>
          <b>{{ 'Deutsch' | translate }}</b>
        </div>
        <div class="flex-fill pl-2 align-self-center">
          <img class="flag" src="images/flags/{{ getLanguageFlag(selectedTranslateLanguage) }}"/>
          <b>{{ translateLanguage(selectedTranslateLanguage) }}</b>
        </div>
      </div>
    </div>

    <div class="container-fluid px-0">
      <div class="row g-3">
        <!-- DESCRIPTION_SHORT -->
        <div class="col-12">
          <div class="np-field">
            <np-inputControl
                (elementSelected)="elementSelectFunction($event)"
                (excelElementDropped)="excelElementDrop($event)"
                (onValueChanged)="update($event)"
                [(model)]="model"
                [(productTranslation)]="productTranslation"
                [(selectedElements)]="selectedElements"
                [dragFilter]="dragFilter"
                [showDragHandle]="showDragHandle"
                [showLinkButtons]="showLinkButtons"
                [showPlaceLabel]="model?.descriptionShort?.length > 0"
                [showTranslationPlaceLabel]="productTranslation?.descriptionShort?.length > 0"
                [suppressTranslation]="false"
                field="DESCRIPTION_SHORT"
                labelText="{{ 'Produktbeschreibung' | translate }}"
            >
              <div class="contentSlot" slot="content">
                <dx-text-box
                    (onValueChanged)="update($event, 'DESCRIPTION_SHORT')"
                    [(value)]="model.descriptionShort"
                    [readOnly]="readOnlyForLinkedFields('DESCRIPTION_SHORT') || readOnly('productDescShort') || massDataChangeMode"
                    [showClearButton]="showClearButton('DESCRIPTION_SHORT')"
                >
                  <dx-validator
                      (onInitialized)="validationService.startAutomaticValidation($event)"
                      *ngIf="!templateView"
                      validationGroup="MAIN"
                  >
                    <dxi-validation-rule
                        [validationCallback]="validationService.validateField('DESCRIPTION_SHORT')"
                        type="async"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>

              <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                <dx-text-box
                    (onValueChanged)="translationUpdate(model.descriptionShort, $event.value)"
                    [(value)]="productTranslation.descriptionShort"
                    [readOnly]="readOnly('productDescShort')"
                    [showClearButton]="true"
                ></dx-text-box>
              </div>
            </np-inputControl>
          </div>
        </div>

        <!-- PRODUKTINFOS + HERSTELLERINFOS -->
        <div class="col-12 col-lg-6 d-flex">
          <div class="np-section h-100 w-100">
            <div class="np-section-header">{{ 'Produktinformationen' | translate }}</div>

            <!-- SUPPLIER_PID -->
            <div class="np-field np-product-number">
              <a
                  *ngIf="loginService.hasAddonWawiErp && !readOnly('productUniqueSID') && !templateView"
                  class="np-inline-action"
                  href=""
                  (click)="getSupplierPid(); $event.preventDefault(); $event.stopPropagation()"
              >
                {{ 'Eindeutige Produktnummer (PID) zuweisen' | translate }}
              </a>

              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.supplierPid?.length > 0"
                  [suppressLinkButton]="true"
                  field="SUPPLIER_PID"
                  labelText="{{ 'Produktnummer' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'SUPPLIER_PID')"
                      [(value)]="model.supplierPid"
                      [readOnly]="readOnly('productId') || massDataChangeMode"
                      [showClearButton]="showClearButton('SUPPLIER_PID')"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('SUPPLIER_PID')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <!-- SUPPLIER_ALT_PID -->
            <div class="np-field" *ngIf="!isPrint">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.supplierAltAid?.length > 0"
                  field="SUPPLIER_ALT_PID"
                  labelText="{{ 'alternative Produktnummer' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'SUPPLIER_ALT_PID')"
                      [(value)]="model.supplierAltAid"
                      [readOnly]="readOnlyForLinkedFields('SUPPLIER_ALT_PID') || readOnly('productAltId') || massDataChangeMode"
                      [showClearButton]="showClearButton('SUPPLIER_ALT_PID')"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('SUPPLIER_ALT_PID')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <!-- INTERNATIONAL_PID + TYPE -->
            <div class="np-field mb-0">
              <div class="row g-2">
                <div class="col-12 col-md-8">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.internationalPid?.length > 0"
                      field="INTERNATIONAL_PID"
                      labelText="{{ 'Internationale ID' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'INTERNATIONAL_PID')"
                          [(value)]="model.internationalPid"
                          [readOnly]="readOnlyForLinkedFields('INTERNATIONAL_PID') || readOnly('productIntId') || massDataChangeMode"
                          [showClearButton]="showClearButton('INTERNATIONAL_PID')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('INTERNATIONAL_PID')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>

                <div class="col-12 col-md-4">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.internationalPidType?.length > 0"
                      [suppressLabel]="false"
                      labelText="{{ 'TYP' | translate }}"
                      field="INTERNATIONAL_PID_TYPE"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-autocomplete
                          (onValueChanged)="update($event, 'INTERNATIONAL_PID_TYPE')"
                          [(value)]="model.internationalPidType"
                          [dataSource]="internationalPidType"
                          [minSearchLength]="0"
                          [readOnly]="readOnlyForLinkedFields('INTERNATIONAL_PID_TYPE') || readOnly('productIntIdType')"
                          [showClearButton]="showClearButton('INTERNATIONAL_PID_TYPE')"
                          [showDropDownButton]="!readOnlyForLinkedFields('INTERNATIONAL_PID_TYPE')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('INTERNATIONAL_PID_TYPE')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-autocomplete>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>

            <!-- REMARKS -->
            <div class="np-field" *ngIf="!isPrint">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.remarks?.length > 0"
                  [showTranslationPlaceLabel]="productTranslation?.remarks?.length > 0"
                  [suppressTranslation]="false"
                  field="REMARKS"
                  labelText="{{ 'Bemerkung' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'REMARKS')"
                      [(value)]="model.remarks"
                      [readOnly]="readOnlyForLinkedFields('REMARKS') || readOnly('productTranslation')"
                      [showClearButton]="showClearButton('REMARKS')"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('REMARKS')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>

                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                  <dx-text-box
                      (onValueChanged)="translationUpdate(model.remarks, $event.value)"
                      [(value)]="productTranslation.remarks"
                      [readOnly]="readOnly('productTranslation')"
                      [showClearButton]="true"
                  ></dx-text-box>
                </div>
              </np-inputControl>
            </div>
          </div>
        </div>

                <div class="col-12 col-lg-6 d-flex">
          <div class="np-section h-100 w-100">
            <div class="np-section-header">{{ 'Herstellerinformationen' | translate }}</div>

            <!-- MANUFACTURER_TYPE_DESCR -->
            <div class="np-field">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.manufacturerTypeDescr?.length > 0"
                  [showTranslationPlaceLabel]="productTranslation?.manufacturerTypeDescr?.length > 0"
                  [suppressTranslation]="false"
                  field="MANUFACTURER_TYPE_DESCR"
                  labelText="{{ 'Herstellerbezeichnung' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'MANUFACTURER_TYPE_DESCR')"
                      [(value)]="model.manufacturerTypeDescr"
                      [height]="46"
                      [readOnly]="readOnlyForLinkedFields('MANUFACTURER_TYPE_DESCR') || readOnly('productPName')"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('MANUFACTURER_TYPE_DESCR')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>

                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                  <dx-text-area
                      (onValueChanged)="translationUpdate(model.manufacturerTypeDescr, $event.value)"
                      [(value)]="productTranslation.manufacturerTypeDescr"
                      [height]="46"
                      [readOnly]="readOnly('productPName')"
                  ></dx-text-area>
                </div>
              </np-inputControl>
            </div>

            <!-- MANUFACTURER_NAME -->
            <div class="np-field" *ngIf="!loginService.hasAddonDataSources">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.manufacturerName?.length > 0"
                  [showTranslationPlaceLabel]="productTranslation?.manufacturerName?.length > 0"
                  [suppressTranslation]="false"
                  field="MANUFACTURER_NAME"
                  labelText="{{ 'Herstellername' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'MANUFACTURER_NAME')"
                      [(value)]="model.manufacturerName"
                      [readOnly]="readOnlyForLinkedFields('MANUFACTURER_NAME') || readOnly('productManuName')"
                      [showClearButton]="showClearButton('MANUFACTURER_NAME')"
                      class="validationBlue"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('MANUFACTURER_NAME')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>

                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                  <dx-text-box
                      (onValueChanged)="translationUpdate(model.manufacturerName, $event.value)"
                      [(value)]="productTranslation.manufacturerName"
                      [readOnly]="readOnly('productManuName')"
                      [showClearButton]="true"
                      class="validationBlue"
                  ></dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <div class="np-field" *ngIf="loginService.hasAddonDataSources">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.manufacturerName?.length > 0"
                  [showTranslationPlaceLabel]="productTranslation?.manufacturerName?.length > 0"
                  [suppressTranslation]="false"
                  field="MANUFACTURER_NAME"
                  labelText="{{ 'Herstellername' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-select-box
                      (onCustomItemCreating)="onManufacturerCustomItemCreating($event)"
                      (onValueChanged)="update($event, 'MANUFACTURER_NAME')"
                      [(value)]="model.manufacturerName"
                      [acceptCustomValue]="true"
                      [dropDownOptions]="dropDownCfg"
                      [items]="manufacturerDataSources"
                      [readOnly]="readOnlyForLinkedFields('MANUFACTURER_NAME') || readOnly('productManuName')"
                      [searchEnabled]="true"
                      [searchExpr]="['name', 'brandName', 'alternativeNames']"
                      [showClearButton]="showClearButton('MANUFACTURER_NAME')"
                      class="validationBlue"
                      displayExpr="name"
                      placeholder=""
                      valueExpr="name"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('MANUFACTURER_NAME')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>

                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                  <dx-text-box
                      (onValueChanged)="translationUpdate(model.manufacturerName, $event.value)"
                      [(value)]="productTranslation.manufacturerName"
                      [readOnly]="readOnly('productManuName')"
                      [showClearButton]="true"
                      class="validationBlue"
                  ></dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <!-- MANUFACTURER_PID -->
            <div class="np-field" *ngIf="!isPrint">
              <np-inputControl
                  (elementSelected)="elementSelectFunction($event)"
                  (excelElementDropped)="excelElementDrop($event)"
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [(selectedElements)]="selectedElements"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.manufacturerAid?.length > 0"
                  field="MANUFACTURER_PID"
                  labelText="{{ 'Herstellerartikelnummer' | translate }}"
              >
                <div class="contentSlot" slot="content">
                  <dx-text-box
                      (onValueChanged)="update($event, 'MANUFACTURER_PID')"
                      [(value)]="model.manufacturerAid"
                      [readOnly]="readOnlyForLinkedFields('MANUFACTURER_PID') || readOnly('productManuAid') || massDataChangeMode"
                      [showClearButton]="showClearButton('MANUFACTURER_PID')"
                      class="validationBlue"
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('MANUFACTURER_PID')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <!-- BRAND_NAME -->
            <div class="np-field" *ngIf="loginService.hasAddonDataSources">
              <np-inputControl
                  (onValueChanged)="update($event)"
                  [(model)]="model"
                  [(productTranslation)]="productTranslation"
                  [dragFilter]="dragFilter"
                  [showDragHandle]="showDragHandle"
                  [showLinkButtons]="showLinkButtons"
                  [showPlaceLabel]="model?.brandName?.length > 0"
                  [showTranslationPlaceLabel]="productTranslation?.brandName?.length > 0"
                  field="BRAND_NAME"
                  labelText="{{ 'Markenname' | translate }}"
                  (excelElementDropped)="excelElementDrop($event)"
              >
                <div class="contentSlot" slot="content">
                  <dx-select-box
                      (onValueChanged)="update($event, 'BRAND_NAME')"
                      [(value)]="model.brandName"
                      [acceptCustomValue]="true"
                      [items]="possibleBrandNames"
                      [openOnFieldClick]="true"
                      [readOnly]="readOnlyForLinkedFields('BRAND_NAME') || readOnly('productBrandName')"
                      [searchEnabled]="true"
                      [showClearButton]="showClearButton('BRAND_NAME')"
                      placeholder=""
                  >
                    <dx-validator
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                        *ngIf="!templateView"
                        validationGroup="MAIN"
                    >
                      <dxi-validation-rule
                          [validationCallback]="validationService.validateField('BRAND_NAME')"
                          type="async"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </np-inputControl>
            </div>
          </div>
        </div>

        <!-- DESCRIPTION_LONG -->
        <div class="col-12">
          <div class="row g-3 align-items-start">
            <div class="col">
              <div class="np-field mb-0">
                <np-inputControl
                    (elementSelected)="elementSelectFunction($event)"
                    (excelElementDropped)="excelElementDrop($event)"
                    (onValueChanged)="update($event)"
                    (showHTMLEditorChange)="showHTMLEditorChanged()"
                    [(model)]="model"
                    [(productTranslation)]="productTranslation"
                    [(selectedElements)]="selectedElements"
                    [(showHTMLEditor)]="showHTMLEditor"
                    [dragFilter]="dragFilter"
                    [isPrint]="isPrint"
                    [showDragHandle]="showDragHandle"
                    [showHTMLSwitch]="showHTMLSwitch"
                    [showLinkButtons]="showLinkButtons"
                    [suppressPlaceLabel]="true"
                    [suppressTranslation]="false"
                    field="DESCRIPTION_LONG"
                    labelText="{{ 'Langbezeichnung' | translate }}"
                >
                  <div class="contentSlot" slot="content">
                    <div *ngIf="showHTMLEditor && !isPrint" class="w-100">
                      <dx-html-editor
                          (onFocusOut)="update($event, 'DESCRIPTION_LONG')"
                          [(value)]="model.descriptionLong"
                          [readOnly]="readOnlyForLinkedFields('DESCRIPTION_LONG') || readOnly('productDescLong')"
                          allowSoftLineBreak="true"
                          class="w-100"
                          placeholder="DESCRIPTION_LONG"
                      >
                        <dxo-toolbar>
                          <dxi-item name="undo"></dxi-item>
                          <dxi-item name="redo"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="bold"></dxi-item>
                          <dxi-item name="italic"></dxi-item>
                          <dxi-item name="strike"></dxi-item>
                          <dxi-item name="underline"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="alignLeft"></dxi-item>
                          <dxi-item name="alignCenter"></dxi-item>
                          <dxi-item name="alignRight"></dxi-item>
                          <dxi-item name="alignJustify"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item [acceptedValues]="[1, 2, 3, 4, 5, false]" name="header"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="orderedList"></dxi-item>
                          <dxi-item name="bulletList"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="link"></dxi-item>
                        </dxo-toolbar>

                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-html-editor>
                    </div>

                    <div *ngIf="!showHTMLEditor || isPrint">
                      <label class="placeLabel {{ model?.descriptionLong?.length > 0 ? 'placeLabelSmall' : '' }}">
                        DESCRIPTION_LONG
                      </label>
                      <dx-text-area
                          (onValueChanged)="update($event, 'DESCRIPTION_LONG')"
                          [(value)]="model.descriptionLong"
                          [height]="130"
                          [readOnly]="readOnlyForLinkedFields('DESCRIPTION_LONG') || readOnly('productDescLong')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-area>
                    </div>
                  </div>

                  <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                    <div *ngIf="showHTMLEditor">
                      <dx-html-editor
                          (onValueChanged)="translationUpdate(model.descriptionLong, $event.value)"
                          [(value)]="productTranslation.descriptionLong"
                          [readOnly]="readOnly('productDescLong')"
                          placeholder="DESCRIPTION_LONG"
                      >
                        <dxo-toolbar>
                          <dxi-item name="undo"></dxi-item>
                          <dxi-item name="redo"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="bold"></dxi-item>
                          <dxi-item name="italic"></dxi-item>
                          <dxi-item name="strike"></dxi-item>
                          <dxi-item name="underline"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="alignLeft"></dxi-item>
                          <dxi-item name="alignCenter"></dxi-item>
                          <dxi-item name="alignRight"></dxi-item>
                          <dxi-item name="alignJustify"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item [acceptedValues]="[1, 2, 3, 4, 5, false]" name="header"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="orderedList"></dxi-item>
                          <dxi-item name="bulletList"></dxi-item>
                          <dxi-item name="separator"></dxi-item>
                          <dxi-item name="link"></dxi-item>
                        </dxo-toolbar>

                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                              type="custom"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-html-editor>
                    </div>

                    <div *ngIf="!showHTMLEditor">
                      <label class="placeLabel {{ productTranslation?.descriptionLong?.length > 0 ? 'placeLabelSmall' : '' }}">
                        DESCRIPTION_LONG
                      </label>
                      <dx-text-area
                          (onValueChanged)="translationUpdate(model.descriptionLong, $event.value)"
                          [(value)]="productTranslation.descriptionLong"
                          [height]="130"
                          [readOnly]="readOnly('productDescLong')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('DESCRIPTION_LONG')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-area>
                    </div>
                  </div>
                </np-inputControl>
              </div>
            </div>
          </div>
        </div>

        <!-- EDE Nummern -->
        <div class="col-12" *ngIf="hasAddonEDENUMBERS">
          <div class="np-section">
            <div class="np-section-header">{{ 'EDE Nummern' | translate }}</div>

            <div class="row g-3">
              <div class="col-12 col-lg-6">
                <div class="np-field">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.edeNumber1?.length > 0"
                      field="EDE_NUMBER_1"
                      labelText="{{ 'EDE Nummer' | translate }} 1"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'EDE_NUMBER_1')"
                          [(value)]="model.edeNumber1"
                          [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_1') || readOnly('productEDENumber1')"
                          [showClearButton]="showClearButton('EDE_NUMBER_1')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('EDE_NUMBER_1')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>

                <div class="np-field">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.edeNumber2?.length > 0"
                      field="EDE_NUMBER_2"
                      labelText="{{ 'EDE Nummer' | translate }} 2"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'EDE_NUMBER_2')"
                          [(value)]="model.edeNumber2"
                          [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_2') || readOnly('productEDENumber2')"
                          [showClearButton]="showClearButton('EDE_NUMBER_2')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('EDE_NUMBER_2')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>

                <div class="np-field mb-0">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.edeNumber3?.length > 0"
                      field="EDE_NUMBER_3"
                      labelText="{{ 'EDE Nummer' | translate }} 3"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'EDE_NUMBER_3')"
                          [(value)]="model.edeNumber3"
                          [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_3') || readOnly('productEDENumber3')"
                          [showClearButton]="showClearButton('EDE_NUMBER_3')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('EDE_NUMBER_3')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div class="np-field">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.edeNumber4?.length > 0"
                      field="EDE_NUMBER_4"
                      labelText="{{ 'EDE Nummer' | translate }} 4"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'EDE_NUMBER_4')"
                          [(value)]="model.edeNumber4"
                          [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_4') || readOnly('productEDENumber4')"
                          [showClearButton]="showClearButton('EDE_NUMBER_4')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('EDE_NUMBER_4')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>

                <div class="np-field mb-0">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.edeNumber5?.length > 0"
                      field="EDE_NUMBER_5"
                      labelText="{{ 'EDE Nummer' | translate }} 5"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'EDE_NUMBER_5')"
                          [(value)]="model.edeNumber5"
                          [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_5') || readOnly('productEDENumber5')"
                          [showClearButton]="showClearButton('EDE_NUMBER_5')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('EDE_NUMBER_5')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- UNTERE ELEMENTE -->
        <div class="col-12">
          <div class="np-section">
            <div class="np-section-header">{{ 'Weitere Informationen' | translate }}</div>

            <div class="row g-3">
              <div class="col-12 col-lg-6">
                <!-- KEYWORDS -->
                <div class="np-field" *ngIf="!isPrint">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.keywords?.length > 0"
                      field="KEYWORDS"
                      labelText="{{ 'Suchbegriffe' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-tag-box
                          (onValueChanged)="update($event, 'KEYWORDS')"
                          [(value)]="model.keywords"
                          [acceptCustomValue]="true"
                          [readOnly]="readOnlyForLinkedFields('KEYWORDS') || readOnly('productKeywords')"
                          class="validationOrange"
                          noDataText=""
                          placeholder=""
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('KEYWORDS')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-tag-box>
                    </div>
                  </np-inputControl>
                </div>

                <!--PrintIndex-->
                <div *ngIf="loginService.hasAddonPRINT && !isPrint" class="np-field">
                  <np-inputControl [(model)]="model"
                                   [(productTranslation)]="productTranslation"
                                   [showLinkButtons]="showLinkButtons"
                                   [showPlaceLabel]="model?.printIndexe?.length > 0"
                                   [(selectedElements)]="selectedElements"
                                   (elementSelected)="elementSelectFunction($event)"
                                   (onValueChanged)="update($event)"
                                   labelText="{{ 'PRINTINDEXE' | translate }}"
                                   field="PRINTINDEXE"
                                   [showDragHandle]="showDragHandle"
                                   [dragFilter]="dragFilter"
                                   (excelElementDropped)="excelElementDrop($event)">
                    <div slot="content" class="contentSlot">
                      <dx-tag-box [(value)]="model.printIndexe"
                                  placeholder=""
                                  [readOnly]="readOnlyForLinkedFields('PRINTINDEXE') || readOnly('productPrintIndexe')"
                                  (onValueChanged)="update($event, 'PRINTINDEXE')"
                                  [acceptCustomValue]="true"
                                  noDataText=""
                                  class="validationOrange">
                        <dx-validator *ngIf="!templateView"
                                      validationGroup="MAIN"
                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                          <dxi-validation-rule type="async"
                                               [validationCallback]="validationService.validateField('PRINTINDEXE')"></dxi-validation-rule>
                        </dx-validator>
                      </dx-tag-box>
                    </div>
                  </np-inputControl>
                </div>

                <!-- PRODUCT_ORDER -->
                <div class="np-field">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.productOrder != null"
                      field="PRODUCT_ORDER"
                      labelText="{{ 'Sortiernummer' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-number-box
                          (onValueChanged)="update($event, 'PRODUCT_ORDER')"
                          [(value)]="model.productOrder"
                          [min]="0"
                          [readOnly]="readOnlyForLinkedFields('PRODUCT_ORDER') || readOnly('productSortnumber')"
                          [showClearButton]="showClearButton('PRODUCT_ORDER')"
                          [showSpinButtons]="!readOnlyForLinkedFields('PRODUCT_ORDER')"
                          placeholder=""
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('PRODUCT_ORDER')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-number-box>
                    </div>
                  </np-inputControl>
                </div>

                <!-- ERP_GROUP_BUYER -->
                <div class="np-field" *ngIf="hasAddonPRODUCT_DETAILS && !isPrint">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.erpGroupBuyer?.length > 0"
                      field="ERP_GROUP_BUYER"
                      labelText="{{ 'ERP Gruppe Käufer' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'ERP_GROUP_BUYER')"
                          [(value)]="model.erpGroupBuyer"
                          [readOnly]="readOnlyForLinkedFields('ERP_GROUP_BUYER') || readOnly('productEDEGroupBuyer')"
                          [showClearButton]="showClearButton('ERP_GROUP_BUYER')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('ERP_GROUP_BUYER')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>

                <!-- BUYER_AID -->
                <div class="np-field mb-0" *ngIf="hasAddonPRODUCT_DETAILS && !isPrint">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.buyerAid?.length > 0"
                      field="BUYER_AID"
                      labelText="{{ 'Käufer Artikelnummer' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'BUYER_AID')"
                          [(value)]="model.buyerAid"
                          [readOnly]="readOnlyForLinkedFields('BUYER_AID') || readOnly('productBuyerAid')"
                          [showClearButton]="showClearButton('BUYER_AID')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('BUYER_AID')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <!-- IS_DISCONTINUED + DATE -->
                <div class="np-field">
                  <div class="row g-2 align-items-end">
                    <div class="col">
                      <np-inputControl
                          (elementSelected)="elementSelectFunction($event)"
                          (excelElementDropped)="excelElementDrop($event)"
                          (onValueChanged)="update($event)"
                          [(model)]="model"
                          [(productTranslation)]="productTranslation"
                          [(selectedElements)]="selectedElements"
                          [dragFilter]="dragFilter"
                          [showDragHandle]="showDragHandle"
                          [showLinkButtons]="showLinkButtons"
                          [suppressContentWidth]="templateView"
                          [suppressPlaceLabel]="true"
                          field="IS_DISCONTINUED"
                          labelText="{{ 'Auslaufprodukt' | translate }}"
                      >
                        <div class="contentSlot np-others" slot="content">
                          <np-booleanRadioGroup
                              (onValueChanged)="update($event, 'IS_DISCONTINUED')"
                              [(value)]="model.isDiscontinued"
                              [fieldName]="validationService.fieldNames.isDiscontinued"
                              [readOnly]="readOnlyForLinkedFields('IS_DISCONTINUED') || readOnly('productDiscontinued')"
                              [templateView]="templateView"
                              validatorValidationGroup="MAIN"
                          ></np-booleanRadioGroup>
                        </div>
                      </np-inputControl>
                    </div>

                    <div class="col-auto" *ngIf="model.isDiscontinued == true">
                      <np-inputControl
                          (elementSelected)="elementSelectFunction($event)"
                          (excelElementDropped)="excelElementDrop($event)"
                          (onValueChanged)="update($event)"
                          [(model)]="model"
                          [(productTranslation)]="productTranslation"
                          [(selectedElements)]="selectedElements"
                          [dragFilter]="dragFilter"
                          [showDragHandle]="showDragHandle"
                          [showLinkButtons]="showLinkButtons"
                          [showPlaceLabel]="model?.discontinuedDate != null"
                          [suppressLabel]="true"
                          field="DISCONTINUED_DATE"
                      >
                        <div class="contentSlot" slot="content">
                          <dx-date-box
                              (onValueChanged)="update($event, 'DISCONTINUED_DATE')"
                              [(value)]="model.discontinuedDate"
                              [readOnly]="readOnlyForLinkedFields('DISCONTINUED_DATE') || readOnly('productDiscontinuedDate')"
                              [showClearButton]="showClearButton('DISCONTINUED_DATE')"
                              displayFormat="dd.MM.yyyy"
                              id="date"
                              type="date"
                              valueChangeEvent="focusout"
                          >
                            <dx-validator
                                (onInitialized)="validationService.startAutomaticValidation($event)"
                                *ngIf="!templateView"
                                validationGroup="MAIN"
                            >
                              <dxi-validation-rule
                                  [validationCallback]="validationService.validateField('DISCONTINUED_DATE')"
                                  type="async"
                              ></dxi-validation-rule>
                            </dx-validator>
                          </dx-date-box>
                        </div>
                      </np-inputControl>
                    </div>
                  </div>
                </div>

                <!-- STATUS -->
                <div class="np-field">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.states?.length > 0"
                      field="STATUS"
                      labelText="{{ 'Produktstatus' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-tag-box
                          (onValueChanged)="updateState($event, 'STATUS')"
                          [(value)]="model.states"
                          [acceptCustomValue]="true"
                          [items]="productStates"
                          [readOnly]="readOnlyForLinkedFields('STATUS') || readOnly('productState')"
                          noDataText=""
                          placeholder=""
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('STATUS')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-tag-box>
                    </div>
                  </np-inputControl>
                </div>

                <!-- ERP_GROUP_SUPPLIER -->
                <div class="np-field mb-0" *ngIf="hasAddonPRODUCT_DETAILS && !isPrint">
                  <np-inputControl
                      (elementSelected)="elementSelectFunction($event)"
                      (excelElementDropped)="excelElementDrop($event)"
                      (onValueChanged)="update($event)"
                      [(model)]="model"
                      [(productTranslation)]="productTranslation"
                      [(selectedElements)]="selectedElements"
                      [dragFilter]="dragFilter"
                      [showDragHandle]="showDragHandle"
                      [showLinkButtons]="showLinkButtons"
                      [showPlaceLabel]="model?.erpGroupSupplier?.length > 0"
                      field="ERP_GROUP_SUPPLIER"
                      labelText="{{ 'ERP Gruppe Verkäufer' | translate }}"
                  >
                    <div class="contentSlot" slot="content">
                      <dx-text-box
                          (onValueChanged)="update($event, 'ERP_GROUP_SUPPLIER')"
                          [(value)]="model.erpGroupSupplier"
                          [readOnly]="readOnlyForLinkedFields('ERP_GROUP_SUPPLIER') || readOnly('productEDEGroupSupplier')"
                          [showClearButton]="showClearButton('ERP_GROUP_SUPPLIER')"
                      >
                        <dx-validator
                            (onInitialized)="validationService.startAutomaticValidation($event)"
                            *ngIf="!templateView"
                            validationGroup="MAIN"
                        >
                          <dxi-validation-rule
                              [validationCallback]="validationService.validateField('ERP_GROUP_SUPPLIER')"
                              type="async"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </np-inputControl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dx-validation-group>
</div>

<np-edit-datasource
    (saved)="onEditSaved($event)"
    [(visible)]="popupVisible"
    [dataSource]="newAddedDatasource"
    [editMode]="false"
></np-edit-datasource>

<footer *ngIf="(isMaster() && !readOnly('productLinkAll') && !templateView) || loginService.hasAddonDEVELOPMENT" class="np-footer">
    <dx-button stylingMode="outlined"
               *ngIf="(isMaster() && !readOnly('productLinkAll') && !templateView)"
               type="default"
               text="{{ 'Alle Felder verknüpfen' | translate }}"
               (onClick)="linkAllFields()"></dx-button>
    <dx-button stylingMode="outlined" 
               *ngIf="loginService.hasAddonDEVELOPMENT"
               type="default"
               icon="tips"
               text="{{ 'Produkt im Netz suchen' | translate }}"
               (onClick)="scrapeProduct()"></dx-button>
</footer>
